'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002e$002dPresto$002dRouter$0024$0024anon$002447 from "./presto.-Presto-Router$$anon$47.js";
import * as $j_presto$002e$002dRegister$002dPage$0024 from "./presto.-Register-Page$.js";
var $p;
/** @constructor */
function $c_Lpresto_PrestoRouter$$anon$46() {
  this.bj0 = null;
  this.biS = null;
  this.biT = false;
  this.bj1 = null;
  this.bj2 = false;
  this.bj5 = null;
  this.biY = null;
  this.biZ = false;
  this.biU = null;
  this.biV = false;
  this.biW = null;
  this.biX = false;
  this.bj3 = false;
  this.bj4 = false;
  this.bj0 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
  this.bj5 = "RegisterPage";
}
export { $c_Lpresto_PrestoRouter$$anon$46 as $c_Lpresto_PrestoRouter$$anon$46 };
$p = $c_Lpresto_PrestoRouter$$anon$46.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_PrestoRouter$$anon$46;
/** @constructor */
function $h_Lpresto_PrestoRouter$$anon$46() {
}
export { $h_Lpresto_PrestoRouter$$anon$46 as $h_Lpresto_PrestoRouter$$anon$46 };
$h_Lpresto_PrestoRouter$$anon$46.prototype = $p;
$p.F = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Decoder__tryDecode__Lio_circe_ACursor__s_util_Either(this, c);
});
$p.J = (function() {
  return this.bj0;
});
$p.L = (function() {
  if ((!this.biT)) {
    this.biS = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__constructorNames__sci_List(this);
    this.biT = true;
  }
  return this.biS;
});
$p.O = (function() {
  if ((!this.bj2)) {
    this.bj1 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__io$circe$derivation$ConfiguredDecoder$$decodersDict__sci_Map(this);
    this.bj2 = true;
  }
  return this.bj1;
});
$p.E = (function() {
  return this.bj5;
});
$p.t = (function() {
  if ((!this.biZ)) {
    this.biY = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$();
    this.biZ = true;
  }
  return this.biY;
});
$p.M = (function() {
  if ((!this.biV)) {
    this.biU = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$();
    this.biV = true;
  }
  return this.biU;
});
$p.Q = (function() {
  if ((!this.biX)) {
    this.biW = new $j_presto$002e$002dPresto$002dRouter$0024$0024anon$002447.$c_Lpresto_PrestoRouter$$anon$47();
    this.biX = true;
  }
  return this.biW;
});
$p.w = (function() {
  if ((!this.bj4)) {
    this.bj3 = false;
    this.bj4 = true;
  }
  return this.bj3;
});
$p.G = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__decodeProduct__Lio_circe_HCursor__F1__s_util_Either(this, c, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((\u03b4scrutinee377) => ((p) => \u03b4scrutinee377))($j_presto$002e$002dRegister$002dPage$0024.$m_Lpresto_RegisterPage$())));
});
var $d_Lpresto_PrestoRouter$$anon$46 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_PrestoRouter$$anon$46, "presto.PrestoRouter$$anon$46", ({
  Od: 1,
  a: 1,
  f: 1,
  h: 1,
  d: 1
}));
export { $d_Lpresto_PrestoRouter$$anon$46 as $d_Lpresto_PrestoRouter$$anon$46 };
//# sourceMappingURL=presto.-Presto-Router$$anon$46.js.map
